import React, { FC, PropsWithChildren } from "react";
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { ruRU } from "@mui/material/locale";

const themeLocale = createTheme(
  ruRU,
);

export const ThemeLocale: FC<PropsWithChildren> = ({ children }) => (
  <ThemeProvider theme={themeLocale}>
    { children }
  </ThemeProvider>
);
